/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createAction } from 'redux-actions';

export const DELETE_SESSION = 'gemini/DELETE_SESSION';
export const SEARCH_SESSIONS = 'gemini/SEARCH_SESSIONS';

export const deleteSession = createAction(DELETE_SESSION);
export const searchSessions = createAction(SEARCH_SESSIONS);
